module.exports = __webpack_public_path__ + "img/a3.53540b6e.png";